import { render, staticRenderFns } from "./UploadReceipt.vue?vue&type=template&id=c16cb790&scoped=true&"
import script from "./UploadReceipt.vue?vue&type=script&lang=js&"
export * from "./UploadReceipt.vue?vue&type=script&lang=js&"
import style0 from "./UploadReceipt.vue?vue&type=style&index=0&id=c16cb790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16cb790",
  null
  
)

export default component.exports